import { render } from "./HeroiconsOutlineDuplicate.vue?vue&type=template&id=340d4d26"
const script = {}

import exportComponent from "/Users/viktor/Desktop/projects/u2c/x5-group/mission-accomplished/backend/project/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDuplicate.vue"]])

export default __exports__